define('apps/admin/views/modals/add-product',[
        'app',
        'njs!apps/admin/templates/includes/modals/_add_product(params:tmpl=admin/main/includes/modals/_add_product.html)',
        'apps/admin/views/products-search-results',
    ], function(app, template, ProductsSearchResults) {
        'use strict';

        return Mn.ItemView.extend({

            "findProductXHR": null,

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
                "keyup #prefix": "fetchProducts",
                "change #family_id": "fetchProducts",
                "change #region_code": "fetchProducts",
                "change #status_id": "fetchProducts",
                "click #add-products": "addProducts",
                "submit .admin-form--find-products": 'onSubmit'
            },

            "template": template,

            "modelEvents": {
                "change": "renderProductsSearchResults"
            },

            "initialize": function(){
                this.fetchProducts();
            },

            "onSubmit": function(e){
                e.preventDefault();
            },

            "fetchProducts": function(e) {

                var apiUrl = $('.admin-form--create-licenses').data('api-url'),
                    prefix,
                    regionsObj,
                    familyId,
                    regionCode,
                    countryCode,
                    statusId;

                // get inputs from form if function is called from an event and from initData if called from initialize function
                if (e) {
                    prefix = this.$('#prefix').val();
                    familyId = this.$('#family_id').val();
                    regionCode = this.$('#region_code').val();
                    countryCode = this.$('#region_code').find(":selected").data('country-code');
                    statusId = this.$('#status_id').val();
                } else {
                    regionsObj = _.findWhere(initData.form_choices.regions, {"selected": true});
                    prefix = "";
                    familyId = "";
                    regionCode = regionsObj.region_id;
                    countryCode = regionsObj.country_code;
                    statusId = 1;
                }

                var params = {
                    'family_id': familyId,
                    "prefix": prefix,
                    "region_code": regionCode,
                    "country_code": countryCode,
                    "status_id": statusId,
                    "is_ascending": true
                };

                var requestSettings = {
                    "url": apiUrl,
                    "method": "GET",
                    "data": params,
                    "xhrFields": {
                        "withCredentials": true
                    },
                    "beforeSend": _.bind(function(){
                        // cancel previous request before starting new request
                        if (this.findProductXHR !== null && this.findProductXHR.readystate !== 4) {
                            this.findProductXHR.abort();
                        }
                    }, this),
                };

                this.findProductXHR = $.ajax(requestSettings)
                    .done(_.bind(function(data, textStatus, jqXHR) {
                        this.model.unset('apiMessage');
                        this.model.set({'products': data.products});
                    }, this))
                    .fail(_.bind(function(jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        var statusCode = jqxhr.status;
                        if (statusCode) {
                            var response = JSON.parse(jqxhr.responseText);
                            this.model.set({'products': [], 'apiMessage': response.meta.message});
                        } else {
                            window.console.log("Request Failed: " + err);
                        }
                    }, this));
            },

            "renderProductsSearchResults": function(products) {

                this.productsSearchResults = new ProductsSearchResults({
                    'model': new Backbone.Model({
                        'products': this.model.get('products'),
                        'apiMessage': this.model.get('apiMessage'),
                    }),
                });

                this.$('.add-products__search-results-table').html('').append(this.productsSearchResults.render().$el);

                this.resizeModal();
            },

            "addProducts": function(e){
                var selectedProducts = this.getSelectedProducts();
                this.trigger('addProducts', selectedProducts);
                this.closeModal();
            },

            "getSelectedProducts": function(){
                var products = this.model.get('products');
                var selectedInputs = this.$el.find('.add-products__search-results-table input[type=checkbox]:checked');
                var selectedProductsIds = _.map(selectedInputs, function(item){
                    return item.value;
                });
                var selectedProducts = _.filter(products, function(product){
                    return _.contains(selectedProductsIds, product.id);
                });

                return selectedProducts;
            },

            "resizeModal": function(){
                var $resizeModal = this.$('.comet-modal'),
                    $modalInner = $resizeModal.find('.comet-modal__inner'),
                    $modalContent = $resizeModal.find('.comet-modal__content'),
                    $modalHeaderHeight = $resizeModal.find('.comet-modal__header').height(),
                    $modalFooterHeight = $resizeModal.find('.comet-modal__footer').outerHeight(),
                    availableHeight = window.innerHeight,
                    $newHeight;

                if ($modalInner.length > 0) {
                    $newHeight = availableHeight - ($modalHeaderHeight + $modalFooterHeight + 80); // 80 is for misc spacing and margins
                    if ($newHeight > 775) { $newHeight = 775; }
                    $modalContent.css('max-height', $newHeight);

                    if ($modalContent.get(0).scrollHeight > $modalContent.innerHeight()) {
                        $modalInner.addClass("comet-modal--scrollable");
                    } else {
                        $modalInner.removeClass("comet-modal--scrollable");
                    }
                }
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });
});

